import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/fr';

import enLang from './lang/en.json';
import frLang from './lang/fr.json';
import itLang from './lang/it.json';
import esLang from './lang/es.json';
import deLang from './lang/de.json';
import nlLang from './lang/nl.json';

const resources = {
  en: {
    translation: enLang,
  },
  fr: {
    translation: frLang,
  },
  it: {
    translation: itLang,
  },
  es: {
    translation: esLang,
  },
  de: {
    translation: deLang,
  },
  nl: {
    translation: nlLang,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: window.localStorage.getItem('lang') || 'fr',
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: ['en', 'fr'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

moment.locale(window.localStorage.getItem('lang') || 'fr');

export const tr = (key, options = {}) => i18n.t(key, options);

export default i18n;
